import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../App.css'; // Add your styling if needed

const SingleDevicePage = () => {
    const { id } = useParams(); // Extract the device ID from the route
    const [device, setDevice] = useState(null);
    const token = localStorage.getItem('token');
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    useEffect(() => {
        const fetchDeviceDetails = async () => {
            try {
                const response = await fetch(`${API_URL}/api/devices/${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch device details');
                }
                const data = await response.json();
                setDevice(data);
            } catch (error) {
                console.error('Error fetching device details:', error);
            }
        };

        fetchDeviceDetails();
    }, [id]);

    if (!device) return <p>Loading device details...</p>;

    return (
        <div className="device-details">
            <h1>{device.name}</h1>
            <p>Type: {device.type}</p>
            <p>Position: x={device.position?.x}, y={device.position?.y}</p>
            <p>Latest Data: {JSON.stringify(device.data?.[0]?.values || 'No data')}</p>
        </div>
    );
};

export default SingleDevicePage;
